import { Icons } from '@silverfort/sf-components';
import mainImg from './mainImage.png';
import { FC } from 'react';
import { BlockPage } from '../../../../routings/pages/BlockPage/BlockPage';

export const CloudAIAgentProtectionBlockPage: FC = () => {
    const topics = [
        'Define trusted AI agents with specific security levels to ensure they operate only within approved boundaries.',
        'Secure MCP servers and connected tools using verified, identity-based permissions for both users and AI agents.',
        'Enforce precise authorization policies that govern what actions AI agents can perform under specified conditions.',
        'Maintain continuous protection by validating every interaction across agents, users, tools, and integrations.'
    ];

    return (
        <BlockPage
            leftContent={{
                image: mainImg,
                title: 'AI Agent Access Control'
            }}
            rightContent={{
                accessLink: 'https://www.silverfort.com/ai-agents-security-signup/',
                badgeProps: {
                    text: 'License Upgrade',
                    color: 'positive',
                    icon: 'Star'
                },
                icon: Icons.Magic,
                title: 'AI Agent Access Control Starts here',
                description:
                    'Extend your identity protection to include AI agents and the tools they access, delivering safety, control, and accountability for every action performed through AI agents in your environment.',
                topics: topics
            }}
        />
    );
};
